import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { LocationStrategy } from '@angular/common';
import { provideAnimations } from '@angular/platform-browser/animations';
import { routes } from './app.routes';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
  HttpClient
} from '@angular/common/http';
import { SubIdInterceptor } from '@shared-interceptors/sub-id.interceptor';
import { BaseUrlInterceptor } from '@shared-interceptors/base-url.interceptor';
import { JwtInterceptor } from '@shared-interceptors/jwt.interceptor';
import { LoaderInterceptor } from '@shared-interceptors/loader.interceptor';
import { APP_INITIALIZER } from '@angular/core';
import { FileMetaDataEnvService } from '../assets/env/services/file-metadata-env.service';
import { initializeApp } from 'firebase/app';
import { environment } from '@environments/environment';
import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideMarkdown } from 'ngx-markdown';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/locales/', '.json');
}

// Function to initialize Firebase
const initializeFirebase = () => {
  return () => {
    initializeApp(environment.firebase);
  };
};

// Function to load environment variables before the app initializes
const initializeEnv = (envService: FileMetaDataEnvService) => {
  return () => envService.loadEnvFile();
};



export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
    provideMarkdown(),
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: SubIdInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: BaseUrlInterceptor, multi: true },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeFirebase,
      multi: true,
    },
    FileMetaDataEnvService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeEnv,
      deps: [FileMetaDataEnvService],
      multi: true,
    },
    // Import translate module providers for standalone components
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
      })
    ),

  ],
};
